import SliderInput from './Slider';
import { useLanguage } from '../../context/LanguageContext';

export default function SliderImportance({ value, onChange }) {
  const { t } = useLanguage();

  return (
    <SliderInput
      description={[
        `${t('notImportant')}`,
        `${t('slightImportant')}`,
        `${t('moderateImportant')}`,
        `${t('important')}`,
        `${t('veryImportant')}`,
      ]}
      value={value}
      onChange={onChange}
    />
  );
}
